import { useEffect } from "react";
import { ImageBackground, Linking, Platform } from "react-native";
import { Loader } from "../../../components/design-system/Loader";
import { Heading, ScrollView, View } from "tamagui";
import { BcIcon } from "../../../components/design-system/icons";
import { Button } from "../../../components/design-system";
import { customColorTokens } from "../../../../tamagui.config";
import { NavigationProp, useNavigation } from "@react-navigation/native";
import { BaseNavigatorParamList } from "../../../navigators/BaseNavigator";
import { EventCard } from "../../../components/design-system/EventCard";
import { useApiQuery } from "../../../../lib/api";
import type { Event } from "../../../types/event";

export const EventShare = ({ eventId }: { eventId: string }) => {
  const { data, isLoading } = useApiQuery<{ event: Event }>(
    ["events", eventId],
    `/api/v1/events/${eventId}`,
    { enabled: !!eventId }
  );

  const event = data?.event;
  const navigation = useNavigation<NavigationProp<BaseNavigatorParamList>>();

  useEffect(() => {
    if (Platform.OS !== "web" && event?.id) {
      navigation.reset({
        index: 0,
        routes: [
          { name: "Home" },
          {
            name: "EventDetail",
            params: { eventId: event.id },
          },
        ],
      });
    }
  }, [navigation, event?.id]);

  return (
    <ImageBackground
      style={{
        flex: 1,
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
        width: "100%",
      }}
      source={require("../../../../assets/pattern.png")}
    >
      {isLoading ? (
        <Loader />
      ) : (
        <ScrollView
          pos="relative"
          overflow="scroll"
          w="100%"
          py={20}
          px="$4"
          $gtMd={{
            justifyContent: "center",
            alignItems: "center",
          }}
          contentContainerStyle={{ flex: 1 }}
        >
          <View
            justifyContent="center"
            alignItems="center"
            flexDirection="column"
            gap={20}
            pt="$4"
          >
            <Heading textTransform="uppercase" size="$3" textAlign="center">
              Someone invited you to a ride!
            </Heading>
            <View w={350}>
              {event ? (
                <EventCard
                  disableLink
                  event={{
                    ...event,
                    groups: [],
                    terrain: event.terrain ?? "Road",
                  }}
                />
              ) : null}
            </View>
            <Button
              bg="yellow"
              onPress={() =>
                Linking.openURL("https://breakfastclubatx.com/club")
              }
              backgroundColor={customColorTokens.brandYellow}
              hoverStyle={{
                backgroundColor: customColorTokens.brandYellow,
                borderColor: "black",
                borderWidth: 1,
              }}
            >
              JOIN THE CLUB
            </Button>

            <BcIcon width={44} height={44} />
          </View>
        </ScrollView>
      )}
    </ImageBackground>
  );
};
